import Component from 'components/DevLogExplorer/index';
import VisTestsCompare from 'components/DevLogExplorer/VisTestsCompare';
import * as React from 'react';

export default {
  log() {
    return <Component />;
  },
  compare() {
    return (
      <VisTestsCompare
        devDirUrl1="https://yastatic.net/s3/milab/2021/old-words/front-v1/builds/v059-14456/dev-22e9de7"
        devDirUrl2="https://yastatic.net/s3/milab/2021/old-words/front-v1/builds/v047-4b871/dev-9fb720f"
      />
    );
  },
};
